module.exports = __webpack_public_path__ + "img/berkeley-dagger.c20e51ed.svg";